module.exports = __webpack_public_path__ + "img/member_info_card.2be8234b.png";